import Tree from './tree.element.js';

export default Tree;

Tree.define('wje-tree', Tree);
